import React, { useState } from 'react'
import { 
  Plus,
  Download,
  ArrowLeft,
  ChevronRight,
  Home
} from 'lucide-react'
import DataTable from '../../components/DataTable/DataTable'
import { useNavigate } from 'react-router-dom'
// Consolidated CSS is imported globally'

const DropdownMaster = () => {
  const navigate = useNavigate()
  const [selectedRows, setSelectedRows] = useState([])

  const data = [
    {
      id: 1,
      dropdownCategory: 'Status',
      label: 'Active',
      value: 'active',
      order: 1,
      status: 'Active',
      createdDate: '2023-01-01'
    },
    {
      id: 2,
      dropdownCategory: 'Status',
      label: 'Inactive',
      value: 'inactive',
      order: 2,
      status: 'Active',
      createdDate: '2023-01-01'
    },
    {
      id: 3,
      dropdownCategory: 'Priority',
      label: 'High',
      value: 'high',
      order: 1,
      status: 'Active',
      createdDate: '2023-02-15'
    },
    {
      id: 4,
      dropdownCategory: 'Priority',
      label: 'Medium',
      value: 'medium',
      order: 2,
      status: 'Active',
      createdDate: '2023-02-15'
    },
    {
      id: 5,
      dropdownCategory: 'Priority',
      label: 'Low',
      value: 'low',
      order: 3,
      status: 'Active',
      createdDate: '2023-02-15'
    },
    {
      id: 6,
      dropdownCategory: 'Department',
      label: 'Sales',
      value: 'sales',
      order: 1,
      status: 'Active',
      createdDate: '2023-03-20'
    },
    {
      id: 7,
      dropdownCategory: 'Department',
      label: 'Marketing',
      value: 'marketing',
      order: 2,
      status: 'Active',
      createdDate: '2023-03-20'
    },
    {
      id: 8,
      dropdownCategory: 'Department',
      label: 'IT',
      value: 'it',
      order: 3,
      status: 'Inactive',
      createdDate: '2023-03-20'
    }
  ]

  const columns = [
    {
      accessorKey: 'dropdownCategory',
      header: 'Category',
      cell: ({ getValue }) => (
        <div className="category-cell">
          <span className="category-text">{getValue()}</span>
        </div>
      ),
    },
    {
      accessorKey: 'label',
      header: 'Label',
      cell: ({ getValue }) => (
        <div className="label-cell">
          <span className="label-text">{getValue()}</span>
        </div>
      ),
    },
    {
      accessorKey: 'value',
      header: 'Value',
      cell: ({ getValue }) => (
        <div className="value-cell">
          <span className="value-text">{getValue()}</span>
        </div>
      ),
    },
    {
      accessorKey: 'order',
      header: 'Order',
      cell: ({ getValue }) => (
        <div className="order-cell">
          <span className="order-text">{getValue()}</span>
        </div>
      ),
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ getValue }) => (
        <div className="status-cell">
          <span className={`status-badge ${getValue().toLowerCase()}`}>{getValue()}</span>
        </div>
      ),
    },
    {
      accessorKey: 'createdDate',
      header: 'Created Date',
      cell: ({ getValue }) => (
        <div className="date-cell">
          <span className="date-text">{getValue()}</span>
        </div>
      ),
    },
  ]

  const handleBack = () => {
    navigate('/settings?tab=masters')
  }

  const handleAddNew = () => {
    navigate('/settings/dropdown-master/form')
  }

  const handleExport = () => {
    console.log('Export Dropdown Master data')
  }

  const handleEdit = (rowData) => {
    navigate('/settings/dropdown-master/edit', { state: { rowData } })
  }

  const handleView = (rowData) => {
    navigate('/settings/dropdown-master/view', { state: { rowData } })
  }

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Breadcrumb Navigation */}
        <div className="breadcrumb-section">
          <nav className="breadcrumb-nav">
            <button className="breadcrumb-item" onClick={() => navigate('/settings')}>
              <span>Settings</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <button className="breadcrumb-item" onClick={() => navigate('/settings?tab=masters')}>
              <span>Masters</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <span className="breadcrumb-current">Dropdown Master</span>
          </nav>
        </div>

        {/* Header Section */}
        <div className="page-header">
          <div className="header-left">
            <button className="back-btn" onClick={handleBack}>
              <ArrowLeft size={20} />
            </button>
            <div className="page-title">
              <h1>Dropdown Master</h1>
              <p>Manage dropdown options and lists used across the application</p>
            </div>
          </div>
          <div className="header-actions">
            <button className="btn-outline" onClick={handleExport}>
              <Download size={18} />
              Export
            </button>
            <button className="btn-primary" onClick={handleAddNew}>
              <Plus size={18} />
              Add New
            </button>
          </div>
        </div>

        {/* Data Table Section */}
        <div className="card">
          <div className="card-body">
            <DataTable
              data={data}
              columns={columns}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              enableSelection={true}
              enablePagination={true}
              pageSize={10}
              onView={handleView}
              onEdit={handleEdit}
              title="Dropdown Options"
            />
          </div>
        </div>

        {/* Summary Section */}
        <div className="summary-section">
          <div className="summary-cards">
            <div className="summary-card">
              <div className="summary-icon">
                <div className="icon-bg active">
                  <span>8</span>
                </div>
              </div>
              <div className="summary-content">
                <h3>Total Options</h3>
                <p>All dropdown options</p>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon">
                <div className="icon-bg active">
                  <span>7</span>
                </div>
              </div>
              <div className="summary-content">
                <h3>Active Options</h3>
                <p>Currently in use</p>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon">
                <div className="icon-bg inactive">
                  <span>1</span>
                </div>
              </div>
              <div className="summary-content">
                <h3>Inactive Options</h3>
                <p>Disabled or archived</p>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon">
                <div className="icon-bg categories">
                  <span>3</span>
                </div>
              </div>
              <div className="summary-content">
                <h3>Categories</h3>
                <p>Different dropdown categories</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownMaster
